import { AccordionItem, List, Stack, Strong, Text } from 'braid-design-system';

export const VariationOfTerms = () => (
  <AccordionItem id="variation-of-terms" label="Variation of Terms">
    <List type="number" start={2}>
      <Stack space="medium">
        <Text />
        <List type="alpha">
          <Text>
            Subject to clauses 2b) and 2c), we may vary these Terms from time to
            time and the updated version will apply to you. Our current terms
            are accessible through the SEEK Developer Site.
          </Text>
          <Text>
            You will be notified of any changes to these Terms which we
            reasonably believe will be materially detrimental to you (
            <Strong>Detrimental Change</Strong>) 30 days prior to them taking
            effect (<Strong>Notice Period</Strong>).
          </Text>
          <Text>
            In the event of a proposed Detrimental Change, you may elect to
            terminate the relevant aspect of your agreement with us during the
            Notice Period by providing at least 5 days&apos; written notice. For
            the avoidance of doubt, your agreement with us in relation to
            products and services not subject to the Detrimental Change will
            otherwise remain on foot (to the extent possible).
          </Text>
        </List>
      </Stack>
    </List>
  </AccordionItem>
);
